import { getRequestSingle } from '../services/requestHandler';

export interface SerialMstr {
  serialMstrId: number;
  laserNo: string;
  // Add other fields as needed
}

export interface SerialNumberSearchResponse {
  data: SerialMstr[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
  pageSize: number;
}

export interface GetSerialMstrsByLaserFilterParams {
  filter: string;
  pageSize?: number;
  currentPage?: number;
  pagesToGet?: number;
}

export const getSerialMstrsByLaserFilter = async ({ filter, pageSize = 10, currentPage = 0, pagesToGet = 1 }: GetSerialMstrsByLaserFilterParams): Promise<SerialNumberSearchResponse> => {
  const params = new URLSearchParams({
    filter: filter,
    pageSize: pageSize.toString(),
    currentPage: currentPage.toString(),
    pagesToGet: pagesToGet.toString(),
  });

  const url = `/rnd/GetSerialMstrsByLaserFilter?${params.toString()}`;
  const response = await getRequestSingle<SerialNumberSearchResponse>('GetSerialMstrsByLaserFilter', url);

  // Transform the response to match the expected structure
  return {
    data: response.data || [],
    totalItems: response.totalItems || 0,
    currentPage: response.currentPage || 0,
    totalPages: response.totalPages || 0,
    pageSize: response.pageSize || 10,
  };
};

export default getSerialMstrsByLaserFilter;
